import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "normConfig", "statusConfig", "unitTypeConfig", "configRow"]

  connect() {
    this.updateConfigs()
  }

  toggle() {
    this.updateConfigs()
  }

  updateConfigs() {
    const getSelectedValues = (type) => {
      return this.checkboxTargets
        .filter(cb => cb.dataset.type === type && cb.checked)
        .map(cb => cb.value)
        .join(',')
    }


    this.normConfigTarget.textContent = getSelectedValues('norm');
    this.statusConfigTarget.textContent = getSelectedValues('status');
    this.unitTypeConfigTarget.textContent = getSelectedValues('unit_type');

    this.toggleConfigRow();
  }

  toggleConfigRow() {
    this.configRowTargets.forEach(row => {
      const codeElement = row.querySelector('code');
      const hasContent = codeElement.textContent.trim() !== '';
      row.classList.toggle('opacity-30', !hasContent);
    });
  }

  copyToClipboard(event) {
    const codeElement = event.currentTarget.previousElementSibling;
    const text = codeElement.textContent;
    navigator.clipboard.writeText(text);
  }
}
